import qs from 'qs';

class QueryStringService {
  private queryString?: any;

  register(search: string) {
    this.queryString = qs.parse(search);
  }

  get() {
    return this.queryString;
  }

  getAsRefOptions() {
    if (this.queryString?.ref) {
      return {
        ref: {
          ref: this.queryString.ref,
          source: 'conversed-webclient',
        },
      };
    }
    return {};
  }
}

export default new QueryStringService();
